// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"MainHeader_headerWrapper__wWyzi","header":"MainHeader_header__hZF4p","logo":"MainHeader_logo__RQ_Fu","logoImage":"MainHeader_logoImage__qDWee"};